import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css"
import { useCreateOrUpdateOrderMutation, useGetOrdersQuery, useUpdatetUserOrderMutation } from "../store/api/orderAPI";
import { orderColumn } from "../metadata/order";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { useParams } from "react-router-dom";
import { generateTrackingCode } from "./SetUser";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import ShippingLabel from "../components/common/PrintOrderLabel";
import { t } from "i18next";
import TrackModal from "./TrackModal";
import { useSelector } from "react-redux";
import { useGetUsersQuery } from "../store/api/userAPI";




function Order() {
	const { id } = useParams()
	const { auth } = useSelector(state => state.auth);
	const [formData, setFormData] = useState({});
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const [newUser, setNewUser] = useState({});
	const { data: newUserData, error: newUserErr, isLoading: newUserLoad } = useGetUsersQuery(
		{
			search: newUser?.new_user
		}, {
		skip: !newUser?.new_user
	}
	);
	const role = auth?.role ?? 'Админ';
	const { data, isLoading } = useGetOrdersQuery(id);
	const [trackModal, setTrackModal] = useState({ visible: false, trackingNumber: null });
	const toast = useRef(null);
	const barcodeRef = useRef(null);
	const [updateUser] = useUpdatetUserOrderMutation()
	const orderColumnTr = useTranslatedColumns(orderColumn);
	const [createOrUpdateOrder] = useCreateOrUpdateOrderMutation();
	const printRef = useRef();
	const [printData, setPrintData] = useState(null);

	const triggerPrint = () => {
		if (!printRef.current) return;

		const printContents = printRef.current.innerHTML;
		const win = window.open("", "_blank", "width=700,height=600");
		win.document.write(`
		<html>
		  <head><title>Print</title></head>
		  <body>${printContents}</body>
		</html>
	  `);
		win.document.close();
		win.focus();
		win.print();
		win.close();
	};

	const actions = useActionsHook([
		{
			onClick: (param, data) => {
				if (id == 30) return
				const printProps = {
					logoUrl: data.logoUrl || "/public/logo.png",
					orderNumber: data.tracking_number || "ORD-123456",
					destinationCode: data.country || "Russia",
					recipientName: data.client || "",
					deliveryAddress:
						data.deliveryAddress ||
						`123 Street / Apt 4 / Region / City / 123456 / ${data.country}`,
					barcode: data.tracking_number || "ABC-abc-1234",
					parcelCount: data.parcelCount || "1/1",
				};

				setPrintData(printProps);

				setTimeout(() => {
					triggerPrint();
					setPrintData(null); // очистить после печати
				}, 100);
			},
			icon: "pi pi-print",
		}, {
			onClick: (param, data) => {
				toggleNewUser(true, param, data)
			},
			icon: "pi pi-user",
		}
	])
	const items = [
		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {
				// window.location.href = 'https://react.dev/';
			}
		}
	];



	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	const [userModal, setUserModal] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		if (id == 30) return
		if (id == 15) {
			setFormData(data)
			setVisibleLeft(state => {
				return {
					visible: bool,
					data: data
				}
			})
		}
		if (role == "Админ" || role == "Менеджер") {
			setFormData(data)
			setVisibleLeft(state => {
				return {
					visible: bool,
					data: data
				}
			})
		}
	}

	function toggleNewUser(bool, event, data) {
		if (id == 30) return

		if ((role == "Админ" || role == "Менеджер") || id == 15 || id == 0 || !id) {
			setFormData(data);
			setUserModal(state => {
				return {
					visible: bool,
					data: {
						...data
					}
				}
			})
		}
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	return (
		<>
			<div ref={barcodeRef} style={{ display: "none" }}>
				<svg id="barcode"></svg>
			</div>
			<Toast ref={toast} />
			<PresortDemo
				isLoading={isLoading}
				data={data}
				// header={renderHeader()}
				globalFilterFields={orderColumnTr.map(item => {
					return item.attr
				})}
				paginator
				globalFilter={globalFilterValue}
				column={id == 30 ? orderColumnTr.filter(i => !i.hidden).toSpliced(3, 0, {
					attr: "price",
					attr_en: "category_en",
					label: "Стоимость доставки",
					type: 1,
					hidden: false,
					editor: false,
					body: (data) => {
						let rate = 0;
						if (data.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
							rate = 999;
						} else if (data.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
							rate = 1100;
						}
						const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // округляем вверх до 0.1 кг

						return (data?.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : weight * rate;
					}
				},
					// Элемент 2: Статус и дата оплаты (индекс 4)
					{
						attr: "current_payment_status",
						label: "Статус оплаты",
						type: 1, // или другой тип, если у вас есть кастомный рендеринг для JSX/компонентов
						hidden: false,
						editor: false,
						body: (data) => {
							if (!data) return "Оплата на админке";

							const isPaid = data.current_payment_status === 2;
							const statusText = isPaid ? "Оплачено" : "";

							// Если оплачено и есть дата, форматируем её (иначе просто выводим статус)
							if (isPaid && data.date_payment) {
								const date = new Date(data.date_payment).toLocaleDateString('ru-RU', {
									day: '2-digit',
									month: '2-digit',
									year: 'numeric',
									hour: '2-digit',
									minute: '2-digit'
								});
								return `${statusText} (${date})`;
							}

							return statusText;
						}
					}) : orderColumnTr.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
				toggleSidebar={toggleSidebar}
				scrollHeight={"calc(100vh - 120px)"}
				deleteHandler={(row, field) => {
				}}
				actions={actions}
			/>
			{id == 0 && <SpeedDial
				model={items}
				radius={120}
				type="quarter-circle"
				onClick={() => {
					toggleSidebar(true, {});
				}}
				direction="up-left"
				style={{ right: 15, bottom: 15 }} />}
			<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
				<div className="user-sidebar">
					{!formData?.guid && (
						<div className="inp_button">
							<div
								style={{
									width: "calc(100% - 140px)",
								}}
							>
								<Editor
									label={t("tracking_number")}
									data={formData}
									attr="tracking_number"
								/>
							</div>
							<MyButton
								label={t("generateCod")}
								onClick={async () => {
									setFormData((prev) => ({
										...prev,
										tracking_number: generateTrackingCode(),
									}));
								}}
							/>
						</div>
					)}
					<div className="user-sidebar-edit">
						{
							orderColumnTr.filter((i) => i.editor).map(el => {
								return (
									<div>
										<Editor {...el} onBlur={onBlur} data={formData} />
									</div>
								)
							})
						}
						<div></div>
						<MyButton label={t("save")} onClick={async () => {
							const { data } = await createOrUpdateOrder(formData);
							if (data?.success) {
								toast.current.show({ severity: 'info', summary: 'Заказ успешно сохранен!', detail: t("successSaved"), life: 3000 });
								toggleSidebar(false)
							} else {
								toast.current.show({ severity: 'error', summary: 'Не удалось сохранить, проверьте правильность заполнения полей!', life: 3000 });
								return
							}
						}} />
					</div>
				</div>

			</Sidebar>
			<Sidebar visible={userModal.visible} position="right" onHide={() => { toggleNewUser(false) }} style={{ minWidth: "50vw" }}>
				<p style={{ margin: 0 }}>Перекидывать посылку на другого клиента:</p> <br />
				<Editor onBlur={(e, attr, value) => {
					setNewUser(state => ({ ...state, [attr]: value }))
				}} data={newUser} attr="new_user" placeholder="Поиск пользователя..." /><br />
				<div>{!!(Array.isArray(newUserData?.data) && newUserData?.data.length) ? (newUserData?.data[0].email + " " + newUserData?.data[0].client_code) : "Пользователь не найден!"}</div>
				<br />{!!(Array.isArray(newUserData?.data) && newUserData?.data.length) && <MyButton label={t("save")} onClick={async () => {
					const { data } = await updateUser({
						guid: formData.guid,
						new_user_guid: newUserData.data[0].guid
					});

					if (data.success) {
						toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
						toggleNewUser(false)
					} else {
						toast.current.show({ severity: 'error', summary: 'Не удалось поменять пользователя', life: 3000 });
					}

				}} />}

			</Sidebar>
			<div ref={printRef} style={{ position: "absolute", left: "-9999px" }}>
				{printData && <ShippingLabel {...printData} />}
			</div>

			<TrackModal
				visible={trackModal.visible}
				trackingNumber={trackModal.trackingNumber}
				onHide={() => setTrackModal({ visible: false, trackingNumber: null })}
			/>
		</>);
}

export default Order;